import { render, staticRenderFns } from "./ChevronDoubleRightIcon.vue?vue&type=template&id=048d66bd"
import script from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports